import { render, staticRenderFns } from "./cookiesPage.vue?vue&type=template&id=84442ee6"
import script from "./cookiesPage.vue?vue&type=script&lang=ts"
export * from "./cookiesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports